import React, { Fragment } from 'react';
import { useFormikContext } from 'formik';
import { BucketFormikInput as Field } from 'Src/types/forms';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { Title } from 'Components/frameworks/title/Title';
import type { LegalAgreementOptin } from 'Components/lines/prebooking-form-line/PrebookingFormLine.utils';
import type { FormValues } from './PrebookingForm.utils';

type Props = {
  legalAgreement: LegalAgreementOptin;
};

export const getLegalAgreementHref = (url: string) => {
  const trimmedUrl = url.trim();

  if (!trimmedUrl) {
    return '';
  }

  return trimmedUrl.startsWith('http') ? trimmedUrl : `https://${trimmedUrl}`;
};

export const PrebookingLegalAgreement = ({ legalAgreement }: Props) => {
  const { errors, submitCount, touched } = useFormikContext<FormValues>();
  const href = getLegalAgreementHref(legalAgreement.url);
  const errorMessage = errors.legalAgreement;
  const showError =
    (Boolean(touched.legalAgreement) || submitCount > 0) && typeof errorMessage === 'string';

  return (
    <div className="mt-10 w-full px-10" data-testid="prebooking-legal-agreement">
      <Title className="mb-10" theme="title-brand-n2">
        {legalAgreement.title}
      </Title>
      <Capsule
        header="none"
        className="flex"
        additionalStyle={{
          content: {
            padding: '1.25rem',
          },
        }}
      >
        <div className="flex">
          <Field
            isRequired={legalAgreement.required}
            isValidate={false}
            className="flex-none p-20"
            name="legalAgreement"
            type="checkbox"
            dataTestId="legal-agreement-field"
            isFlex={false}
          />
          <div className="mb-10 whitespace-pre-wrap text-black">
            <span>{legalAgreement.description}</span>
            {href && legalAgreement.urlLabel ? (
              <Fragment>
                <br />
                <a href={href} rel="noopener noreferrer" target="_blank">
                  <span className="underline">{legalAgreement.urlLabel}</span>
                </a>
              </Fragment>
            ) : null}
          </div>
        </div>
      </Capsule>
      {showError ? (
        <p className="mt-10 text-14 text-red" data-testid="legal-agreement-error">
          {errorMessage}
        </p>
      ) : null}
    </div>
  );
};
